import restApi from '@/rest-api'

export default {
    getTransactionsByFilter(page, filter, sortOption, order) {
        var path = page ? `/transaction/filtered?page=${page}&per_page=10&` : '/transaction/filtered?'
        if (sortOption) {
            path += `sortOption=${sortOption}&order=${order}`
        }
        return restApi.post(path, filter)
    }
}
